var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill"},[_c('div',{staticClass:"progress-value"},[_c('div',{staticClass:"progress-message"},[_vm._v(_vm._s(_vm.message))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }